// extracted by mini-css-extract-plugin
export var banner = "_o6-0";
export var settingRow = "_o6-2";
export var titleIcon = "_o6-1";